<template>
	<v-text-field
		:model-value="dateValue"
		v-bind="$attrs"
		:label="$gettext(label)"
		placeholder="DD-MM-YYYY"
		maxlength="10"
		:rules="[i => !!i || $gettext(requiredMessage),
			i => (/^(0[1-9]|[12][0-9]|3[01])[/-](0[1-9]|1[012])[/-]((19|20)\d{2})$/.test(i) || $gettext('Please fill in a valid date as DD-MM-YYYY')),
			i => customValidator(formatDateToYearFirst(i))]"
		:disabled="disabled"
		variant="outlined"
		@update:model-value="insertDashes"
	>
		<template
			v-if="appendOnValid && dateValue !== null && (dateValue.length > 0) && validateEnteredDate(dateValue)"
			#append-inner
		>
			<v-icon
				color="primary"
				:icon="appendOnValid"
			/>
		</template>
	</v-text-field>
</template>

<script>
export default {
	name: 'DateTextField',

	props: {
		label: {
			type: String,
			default: 'Birth Date',
		},
		modelValue: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		appendOnValid: {
			type: String,
			required: false,
			default: null
		},
		requiredMessage: {
			type: String,
			required: false,
			default: 'Birth date is required'
		},
		customValidator: {
			type: Function,
			required: false,
			default: () => true
		}
	},

	emits: ['update:modelValue',],

	data () {
		return {
			dateValue: ''
		};
	},

	watch: {
		dateValue: {
			/**
			 *
			 */
			handler () {
				this.$emit('update:modelValue', this.formatDateToYearFirst(this.dateValue));
			}
		},

		modelValue: {
			/**
			 * Watch the value passed to the component and set if changed.
			 */
			handler () {
				this.dateValue = this.formatDateToDayFirst(this.modelValue);
			}
		}
	},

	mounted () {
		this.dateValue = this.formatDateToDayFirst(this.modelValue);
	},

	methods: {

		/**
		 * Automatically insert dashes where necessary in the date
		 *
		 * @param {string} date
		 */
		insertDashes (date) {
			const split = date.split('');

			if (split.length >= 3 && !/-/.test(split[2])) {
				let newDate = split[0] + split[1] + '-' + split[2];

				if (split.length >= 4) {
					newDate = newDate + split[3];
				}
				if (split.length >= 5 && !/-/.test(split[4])) {
					newDate = newDate + '-' + split.splice(4).join('');
				} else if (/-/.test(split[4])) {
					newDate = newDate + split.splice(4).join('');
				}
				this.dateValue = newDate;
			} else if (split.length >= 3 && /-/.test(split[2])) {
				let newDate = split[0] + split[1] + split[2];

				if (split.length >= 4) {
					newDate = newDate + split[3];
				}
				if (split.length >= 5) {
					newDate = newDate + split[4];
				}
				if (split.length >= 6 && !/-/.test(split[5])) {
					newDate = newDate + '-' + split.splice(5).join('');
				} else if (/-/.test(split[5])) {
					newDate = newDate + split.splice(5).join('');
				}
				this.dateValue = newDate;
			} else {
				this.dateValue = date;
			}
		},

		/**
		 * Validation for the date of birth field
		 *
		 * @param {string} i
		 * @returns {boolean|boolean|string}
		 */
		validateEnteredDate (i) {
			return (/^(0[1-9]|[12][0-9]|3[01])[/-](0[1-9]|1[012])[/-]((19|20)\d{2})$/.test(i)) && (this.customValidator(this.formatDateToYearFirst(i)) === true);
		},

		/**
		 * Format date from yyyy-mm-dd to dd-mm-yyyy
		 *
		 * @param {string} date
		 * @returns {string|null} - either the formatted string or nothing indicating something went wrong
		 */
		formatDateToDayFirst (date) {
			if (!date) {
				return '';
			}
			const [year, month, day, ] = date.split('-');

			if (day) {
				return `${day}-${month}-${year}`;
			}
			if (month) {
				return `${month}-${year}`;
			}
			return `${year}`;
		},

		/**
		 * Format date from dd-mm-yyyy to yyyy-mm-dd
		 *
		 * @param {string} date
		 * @returns {string|null} - either the formatted string or nothing indicating something went wrong
		 */
		formatDateToYearFirst (date) {
			if (!date) {
				return '';
			}
			const [day, month, year, ] = date.split('-');

			if (year) {
				return `${year}-${month}-${day}`;
			}
			if (month) {
				return `${month}-${day}`;
			}
			return `${day}`;
		},
	}
};
</script>
